import React from "react";
import "./style.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  navigateToContactSection,
  scrollToSectionById,
} from "../../utils/contactNavigation";

interface HeroSectionProps {
  className?: string;
}

const workflow = [
  { title: "Idea", detail: "Capture it privately, in your own words." },
  { title: "Brief", detail: "Shape it into a versioned brief." },
  { title: "Research", detail: "Review the evidence behind each claim." },
  { title: "Decision", detail: "Record what you chose and why." },
];

const InsightWorkflow = () => (
  <div
    className="hero-workflow etlyn-rise"
    style={{ "--rise-delay": "0.25s" } as React.CSSProperties}
    role="img"
    aria-label="Etlyn Insight workflow: idea, brief, research, decision"
  >
    <div className="hero-workflow-header">
      <span className="hero-workflow-dot" aria-hidden="true" />
      <span>Etlyn Insight</span>
    </div>
    <ol className="hero-workflow-list">
      {workflow.map((item, index) => (
        <li
          key={item.title}
          className="hero-workflow-item etlyn-rise"
          style={{ "--rise-delay": `${0.45 + index * 0.1}s` } as React.CSSProperties}
        >
          <span className="hero-workflow-index">{index + 1}</span>
          <span>
            <span className="hero-workflow-title">{item.title}</span>
            <span className="hero-workflow-detail">{item.detail}</span>
          </span>
        </li>
      ))}
    </ol>
  </div>
);

export const HeroSection: React.FC<HeroSectionProps> = ({ className = "" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <section id="home" className={`hero-section ${className}`}>
      <div className="hero-copy">
        <p className="hero-eyebrow etlyn-rise">
          Product development and business analysis
        </p>
        <h1
          className="hero-title etlyn-rise"
          style={{ "--rise-delay": "0.08s" } as React.CSSProperties}
        >
          Give your idea evidence <span>before you build it.</span>
        </h1>
        <p
          className="hero-lede etlyn-rise"
          style={{ "--rise-delay": "0.16s" } as React.CSSProperties}
        >
          Etlyn helps businesses and individuals grow through software. Insight
          brings your ideas, research and decisions into one workflow, and our
          team can analyze, build and test what comes next.
        </p>
        <div
          className="hero-actions etlyn-rise"
          style={{ "--rise-delay": "0.24s" } as React.CSSProperties}
        >
          <button
            type="button"
            data-analytics-target="contact"
            onClick={() => navigateToContactSection(navigate, location.pathname)}
            className="hero-primary"
          >
            Discuss an Insight pilot
          </button>
          <button
            type="button"
            onClick={() => scrollToSectionById("approach")}
            className="hero-secondary"
          >
            See how we work
          </button>
        </div>
        <p
          className="hero-note etlyn-rise"
          style={{ "--rise-delay": "0.32s" } as React.CSSProperties}
        >
          Insight is in early pilot. Tell us what you are testing and we will
          say plainly what is available today.
        </p>
      </div>
      <InsightWorkflow />
    </section>
  );
};
